export default __webpack_public_path__ + "static/media/smappHold.77ed4a99.png";